export const theme = {
  colors: {
    black: '#000',
    blue: '#0080ff',
    danger: '#d9534f',
    globisBlue: '#24387C',
    matBlack: '#263238',
    mediumGray: '#666666',
    white: '#fff',
  },
  colorPallets: {
    primary: {
      normal: '#0080ff',
      hover: '#66b3ff',
      disable: '#b3d9ff',
    },
    cta: {
      normal: '#ff6000',
      hover: '#ffa066',
      disable: '#ffcfb3',
    },
    success: {
      normal: '#00b563',
      background: '#def8ec',
    },
    error: {
      normal: '#ee001d',
      background: '#ffe1e4',
    },
    caution: {
      normal: '#ffca1a',
      background: '#fff9e2',
    },
    mono: {
      black: '#333',
      textGray: '#999',
      line: '#ccc',
      hover: '#ededed',
      background: '#f6f6f6',
    },
  },
  sizes: {
    borderRadius: '4px',
    font: {
      s12: '12px',
      s14: '14px',
      s16: '16px',
      s24: '24px',
      s32: '32px',
    },
  },
  zIndexes: {
    video: {
      overlay: 1001,
      ctrl: 1002,
      progress: 1003,
      progressThumb: 1004,
    },
  },
}
